module.exports = function () {
    var sizes = ["xs", "sm", "md", "lg", "xl"];

    sizes.forEach(function (size) {
        var selector = ".collapsible-" + size + " .title";
        $("body").on("click", selector, function (e) {
            e.preventDefault();
            $(this).parents(".collapsible-" + size).toggleClass("active");

            if ($(this).parents(".collapsible-" + size).hasClass("active")) {
                $(this).attr("aria-expanded", true);
            } else {
                $(this).attr("aria-expanded", false);
            }
            const $collapsibleItem = $(this).parents(".collapsible-" + size);
            const $refinementBar = $collapsibleItem.parents(".refinement-bar");
            const $refinementsWrapper = $collapsibleItem.parents(".refinements-wrapper");

            if ($collapsibleItem.length && $refinementBar.length && $refinementsWrapper.length) {
                const computedStyle = window.getComputedStyle($refinementBar[0]);
                const topPadding = parseInt(computedStyle.paddingTop, 10);
                const elementPosition = $collapsibleItem[0].offsetTop;
                const offsetPosition = elementPosition - topPadding;
        
                $refinementsWrapper[0].scrollTop = offsetPosition;
            }
        });
    });
};
